export const getReportes = 'reportes'
